import React, { useEffect, useState, useCallback } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { confirmAlert } from "react-confirm-alert";
import { URL_LIST_ALL } from "../configs/api";
import Moment from "react-moment";
import FilePreviewList from "./FilePreviewList";
import iconsend from "../assets/img/icon-send.png"
import Loading from "../component/Loading";

export default function XemToTrinh() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams(); // id tờ trình (nếu sửa)
    const { saveWorkfollow } = useSelector((state) => state.save);
    const [detail, setDetail] = useState(null);
    const [myMessage, setMyMessage] = useState("");
    const [listMessage, setListMessage] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);


    const defaultDetail = {
        title: "",
        workflow_type: 0,
        code: "",
        code_file: "",
        status: 1,
        position: 1,
        list_file: []
    };

    const fetchDetail = () => {
        setPageLoading(true)
        Axios.get(URL_LIST_ALL + "xem-to-trinh/" + id, user.config).then((res) => {
            setPageLoading(false)
            if (res.data.status === "success") {
                const dataif = res.data.data || {};
                // dataif.list_file = dataif.list_file && JSON.parse(dataif.list_file)
                dataif.file_watermark = dataif.file_watermark && JSON.parse(dataif.file_watermark)
                dataif.file_attachments = dataif.file_attachments && JSON.parse(dataif.file_attachments)
                let groupedList = groupStepsByPosition(dataif?.workflow_steps_json || []);
                dataif.groupedList = groupedList;

                setListMessage(dataif.messages)
                setDetail(dataif);

            }
        }).catch((e) => {
            console.log(e)
            setPageLoading(false)
        });
    }
    useEffect(() => {
        fetchDetail();
    }, [id]);

    useEffect(() => {
        if (detail && saveWorkfollow) {
            if (saveWorkfollow.workfollow_id == detail.id) {
                if (saveWorkfollow.node_type == 'message') {
                    fetchMessage();
                }
                if (saveWorkfollow.node_type == 'workfollow') {
                    fetchDetail();
                    fetchMessage()
                }
            }
        }
    }, [saveWorkfollow, detail]);

    const fetchMessage = useCallback(() => {
        if (detail) {
            Axios.get(URL_LIST_ALL + "crm_workflow_message?orderby=id-desc&workflow_walking_id=" + detail.id, user.config).then((res) => {
                if (res.data.status === "success") {
                    setListMessage(res.data.data)
                }
            }).catch((e) => console.log(e));
        }
    })

    const formik = useFormik({
        initialValues: detail ? detail : defaultDetail,
        enableReinitialize: true,
        onSubmit: (values, { setSubmitting }) => {
        }
    });

    const groupStepsByPosition = (steps) => {
        const grouped = {};
        steps.forEach(step => {
            const pos = step.position;
            if (!grouped[pos]) {
                grouped[pos] = {
                    step_id: step.id,
                    position: pos,
                    group_name: step.group_name,
                    department_name: step.department_name,
                    timecheck: step.timecheck,
                    member: []
                };
            }
            grouped[pos].member.push({
                id: step.id,
                user_id: step.user_id,
                fullname: step.fullname,
                step_type: step.step_type,
                action: step.action,
                position: pos,
                note_comment: step.note_comment,
                timecheck: step.timecheck
            });
        });
        // sắp xếp theo position tăng dần
        const sorted = Object.values(grouped).sort((a, b) => a.position - b.position);
        // trong mỗi nhóm, ký chính trước phụ sau
        sorted.forEach(g => {
            g.member.sort((a, b) => a.step_type - b.step_type);
        });

        return sorted;
    };



    const sendMessage = () => {
        if (myMessage && myMessage != '') {
            Axios.post(URL_LIST_ALL + 'crm_workflow_message', { workflow_walking_id: id, user_id: user.data.id, message: myMessage }, user.config).then(res => {
                if (res.data.status === "success") {
                    setMyMessage("")
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        }
    }

    const mavTitle = () => {
        if (id) {
            if (detail) {
                if (detail.status == 2) {
                    return "Xem tờ trình"
                } else {
                    if (detail.author_id != user.data.id) {
                        return "Phê duyệt tờ trình"
                    }
                    return "Cập nhật tờ trình"
                }
            } else {
                return "Cảnh báo"
            }
        } else {
            return ""
        }
    }

    return (
        <AkkhorLayout idrole="workflow_walking">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/workflow_walking">Danh sách tờ trình</Link></li>
                    <li>
                        {mavTitle()}
                    </li>
                </ul>
            </div>

            <div className="card height-auto">
                <div className="card-body pb-5">
                    <div className="heading-layout1">
                        <div className="item-title"><h3>{mavTitle()}</h3></div>
                        <div className="">
                            {detail && <>
                                {detail.status == 1 && <span className="text-info">Chưa hoàn tất</span>}
                                {detail.status == 2 && <span className="text-success">Đã được duyệt</span>}
                                {detail.status == 4 && <span className="text-danger">Đã bị hủy</span>}
                            </>}
                        </div>
                    </div>
                    {pageLoading && <Loading />}
                    <form className="new-added-form form-totrinh">
                        {detail ?
                            <>
                                <div className="row">
                                    <div className="col-12 col-sm-3 form-group">
                                        <label>Tên tờ trình</label>
                                        <div className="form-control">
                                            {detail.title}
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-3 form-group">
                                        <label>Số tờ trình</label>
                                        <div className="form-control">
                                            {detail.code}
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-3 form-group">
                                        <label>Loại tờ trình: </label>
                                        <div className="form-control">
                                            {detail.type_name}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3 form-group">
                                        <label>Người tạo</label>
                                        <strong>{detail.author_name}|{detail.author_department}</strong><br />
                                        <small>Ngày tạo: <Moment format="DD/MM/YYYY">{new Date(detail.datecreate * 1000)}</Moment></small>
                                    </div>

                                    <div className="col-12 col-sm-9 form-group">
                                        <div className="w-100">
                                            <label>File scan <span className="text-danger">*</span></label>
                                            <FilePreviewList formik={formik} rowname={"file_watermark"} detail={detail} id={id} />
                                        </div>

                                        {(detail && detail.file_attachments && detail.file_attachments != '' && detail.file_attachments.lenght > 0) && <>
                                            <hr />
                                            <div className="w-100">
                                                <label>Tài liệu tham khảo <small style={{ fontSize: 10 }}>(Không bắt buộc và sẽ không cho vào trong file tờ trình chính)</small></label>
                                                <FilePreviewList formik={formik} rowname={"file_attachments"} detail={detail} id={id} />
                                            </div>
                                        </>}

                                    </div>

                                    <div className="col-12 col-sm-3 form-group message-group">
                                        <div className="w-100 wrapper border rounded">
                                            <div className="w-100 ms-header p-2 border-bottom">
                                                <h5 className="w-100 text-center">Hoạt động</h5>
                                            </div>
                                            <div className="list-message">
                                                {listMessage && listMessage.map((ms) => {
                                                    return <div className="w-100 message-item border-bottom" key={ms.id}>
                                                        <strong>{ms.fullname}:</strong><span>{ms.message}</span><br />
                                                        <small><span className="far fa-clock"></span> <Moment format="H:m DD/MM/YYYY">{new Date(ms.datecreate * 1000)}</Moment></small>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="message-action border-top">
                                                <div className="input-group">
                                                    <input type="text" className="form-control" placeholder="Nhập nội dung..." value={myMessage} onChange={(e) => setMyMessage(e.target.value)} />
                                                    <div className="input-group-prepend">
                                                        <button type="button" className="btn btn-sm btn-succss" onClick={() => sendMessage()}>
                                                            <img src={iconsend} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="row">
                                            <h3 className="w-100 text-center mb-3">Quy trình phê duyệt</h3>
                                            {detail.groupedList && detail.groupedList.map((group) => {
                                                return (
                                                    <div className="col-12 col-sm-4 mb-2 item-totrinh" key={group.position}>
                                                        <div className="wrapper border rounded shaddow">
                                                            <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
                                                                {group.position}. {group.group_name}
                                                            </h4>
                                                            <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
                                                                {group.member.map((m) => (
                                                                    <div className="item-user" key={m.id}>
                                                                        <div className="user-status" >
                                                                            <div className="">
                                                                                <strong>{m.fullname}</strong>
                                                                            </div>

                                                                            <div className="check_status">
                                                                                {m.action == 1 && (
                                                                                    <p className="text-success">
                                                                                        <span className="fas fa-check-circle"></span>
                                                                                        <i className="ml-1"> Đã duyệt</i>

                                                                                    </p>
                                                                                )}
                                                                                {m.action == 2 && (
                                                                                    <p className="text-info">
                                                                                        <span className="fas fa-times-circle"></span>
                                                                                        <i className="ml-1"> Yêu cầu bổ sung</i>
                                                                                    </p>
                                                                                )}
                                                                                {m.action == 3 && (
                                                                                    <p className="text-danger">
                                                                                        <span className="fas fa-times-circle"></span>
                                                                                        <i className="ml-1"> Trả về</i>
                                                                                    </p>
                                                                                )}
                                                                                {m.action == 4 && (
                                                                                    <p className="text-danger">
                                                                                        <span className="fas fa-times-circle"></span>
                                                                                        <i className="ml-1"> Hủy bỏ</i>
                                                                                    </p>
                                                                                )}
                                                                                {m.action == 0 && (
                                                                                    <p className="text-warning">
                                                                                        <span className="fas fa-clock"></span>
                                                                                        <i className="ml-1"> Chờ ký</i>
                                                                                    </p>
                                                                                )}
                                                                                {m.timecheck && <small><span className="far fa-clock"></span><Moment format="H:mm DD/MM/YYYY">{m.timecheck}</Moment></small>}
                                                                            </div>

                                                                        </div>
                                                                        <div className="check-comment">
                                                                            {m.note_comment &&
                                                                                <div className="w-100">
                                                                                    <i className="far fa-comment-dots"></i><small> {m.note_comment}</small>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                </div>
                                {detail.status == 2 &&
                                    <div className="item-totrinh verified">
                                        <div className="wrapper">
                                            <img src="https://apihr.bhsgroup.vn/images/logo-signed.png" />
                                        </div>
                                    </div>
                                }
                            </>
                            :
                            <h3 className="text-danger">Không tìm thấy tờ trình hoặc bạn không có quyền xem tờ trình này</h3>
                        }
                    </form>
                    <div className="w-100 mb-5"></div>
                </div>
            </div>
        </AkkhorLayout>
    );
}
